import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { EndpointResponse } from '@/types/endpoints';
import { DashboardMetrics } from '@/types/dashboard';
import { utils } from '../../utils';
import type { ReadRequestOptions } from '../requestOptions';

type RequestParams = {
  timezone: string;
};

type Response = DashboardMetrics;

const validate = (timezone: string) => {
  if (!timezone) {
    throw new Error('Timezone is required');
  }
};

export const getDashboardMetrics = async (
  scope: RequestScope,
  { timezone }: RequestParams,
  options: ReadRequestOptions
): Promise<EndpointResponse<Response>> => {
  try {
    validate(timezone);

    const result = await scopedApi(scope).get<EndpointResponse<Response>>(`metrics/order_stats?tz=${timezone}&final=1`, options);

    return result.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
